// GraphQL-Crunch is fully backwards-compatible. This module routes into the
// proper implementation.
var versions = [{
  crunch: require("./v1/crunch"),
  uncrunch: require("./v1/uncrunch")
}, {
  crunch: require("./v2/crunch"),
  uncrunch: require("./v2/uncrunch")
}];
module.exports = {
  crunch: function crunch(data) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return version === 1 ? versions[0].crunch(data) : version > versions.length ? versions[0].crunch(data) : {
      version: version,
      crunched: versions[version - 1].crunch(data)
    };
  },
  uncrunch: function uncrunch(data) {
    return data.version == null ? versions[0].uncrunch(data) : versions[data.version - 1].uncrunch(data.crunched);
  }
};